@if (modalService.config(); as config) {
<div class="modal-backdrop" [class.closing]="isClosing()" (click)="onBackdropClick(config.closeOnBackdrop)">
  <div class="modal-content" [class.closing]="isClosing()" (click)="$event.stopPropagation()" [ngStyle]="modalContentExtraStyle()">
    @if (config.title) {
    <div class="modal-header row">
      <h2 class="offset-1 col-10">{{ config.title }}</h2>
      <div class="close-div col-1"><i class="bi bi-x-octagon" (click)="closeWithAnimation(false)"></i></div>
    </div>
    }
    <div class="modal-body">
      <ng-container #outlet />
    </div>
  </div>
</div>
}